import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { RouterProvider, createRouter } from '@tanstack/react-router'

// Fonte (substitui o next/font/google do template)
import '@fontsource-variable/plus-jakarta-sans'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'

// Estilos de terceiros
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-toastify/dist/ReactToastify.css'

// Estilos do projeto
import './globals.css'
import '@assets/iconify-icons/generated-icons.css'

import { routeTree } from './route-tree.gen'
import { queryClient, trpcClient } from './lib/trpc'

const router = createRouter({
  routeTree,
  context: { queryClient, trpcClient },
  defaultPreload: 'intent',
  scrollRestoration: true
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
